import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  phoneNumber: '',
  activeSection: null,
  lastResendTime: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setPhoneNumber(state, action) {
      state.phoneNumber = action.payload;
    },
    setActiveSection(state, action) {
      state.activeSection = action.payload;
    },
    setLastResendTime(state, action) {
      state.lastResendTime = action.payload;
    },
    resetAuthState(state) {
      Object.assign(state, initialState);
    }
  }
});

export const {
  setPhoneNumber,
  setActiveSection,
  setLastResendTime,
  resetAuthState,
} = authSlice.actions;

export default authSlice.reducer;